/** Display formatters for the stats dashboard. */

/** GEL with the ₾ symbol, rounded to whole lari with thousands separators. */
export function formatGel(amount: number): string {
  return `₾ ${Math.round(amount).toLocaleString('en-US')}`;
}

/** GEL with two decimals for analytical totals and exact chart readouts. */
export function formatGelExact(amount: number): string {
  return `₾ ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** A 0..1 ratio or already-percent value rendered as a whole percent. */
export function formatPct(value: number): string {
  return `${Math.round(value)}%`;
}

/**
 * Percent change from prev to curr. Returns null when there is no baseline
 * (prev === 0), so callers can hide the delta chip instead of showing ∞.
 */
export function pctDelta(curr: number, prev: number): number | null {
  if (prev === 0) return null;
  return ((curr - prev) / prev) * 100;
}

/**
 * Compose a user's full display name from first + last name. Last name is
 * optional (nullable on the API, and absent from some denormalized embeds), so
 * this degrades to just the first name when it's missing.
 */
export function fullName(u: {
  first_name?: string | null;
  last_name?: string | null;
}): string {
  const first = (u.first_name ?? '').trim();
  const last = (u.last_name ?? '').trim();
  return [first, last].filter(Boolean).join(' ');
}
